/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// this is a console player 
var MuPlayer = require('mudu-player');
var delegates = require('delegates');
var utils = require('../../helper/utils');
var config = require('../config');
var md5 = require('md5');

module.exports = function () {
    function Player(param) {
        var _this = this;

        (0, _classCallCheck3["default"])(this, Player);

        _scope.Feature.EventBus(this);
        this.id = param.containerId;

        this.useFakeUrl = false;

        this.playerErrorCoverDom = null;
        // 加载player之前挂载错误cover（如果加载了player，此处cover会被冲掉，所以setup之后会再挂载一次）
        this._appendErrorCover();

        var actErrcode = this._getUserInArrearsCode();
        // 如果用户完全欠费，直接挂载错误页
        if (actErrcode && actErrcode.hasLiveErrcode && actErrcode.hasTrailerErrcode) {
            this._displayErrorCover();
            return;
        }

        this.version = param.version;
        this.x5Layer = param.x5Layer || false;
        this.x5Inline = param.x5Inline || false;
        param.src && !param.file && (param.file = param.src); //param.file好像没用到了，兼容之前的sdk
        this.param = param;
        this.timer = new _scope.Timer('User.WatchTime', (0, _extends3["default"])({}, this.param, {
            timegap: 60000,
            getPlayer: function getPlayer() {
                return _this.player;
            }
        }));
        this.player = null;
        this.init(param);

        _scope.MsgBus.Pub('timer.stop', function (timer) {
            // 关闭其他使用当前containerId的播放器的计费
            if (timer.param.containerId == _this.param.containerId && timer != _this.timer) {
                return true;
            }
            return false;
        });

        this._listenBrowserEvent();
    }

    (0, _createClass3["default"])(Player, [{
        key: 'init',
        value: function init() {
            var _this2 = this;

            this.player = MuPlayer(this.id);
            var x5Layer = this.x5Layer;
            var x5Inline = this.x5Inline;

            // 兼容type='live'
            if (this.param.type === 'live') {
                this.param.isLive = true;
                this.param.type = undefined;
            }

            var playerConfig = (0, _extends3["default"])({
                preload: 'none',
                autoplay: this.param.autoplay || this.param.autostart,
                plugin: {
                    x5: {
                        inline: x5Layer, // 让播放器inline播放, 播放器始终位于z-index顶层
                        layer: x5Inline // 让播放器同层播放
                    }
                }
            }, this.param);

            // ？删除会引起冲突的param
            delete playerConfig.x5Layer;
            delete playerConfig.x5Inline;
            delete playerConfig.version;

            // 监听销毁mudusdk消息 销毁时要remove播放器
            this._msgbusDestroy();

            // video_id视频先获取video
            if (!this.param.isLive && this.param.video_id) {
                var resolution = ''; // 如果能匹配到回放视频，就用回放视频的分辨率（其他视频暂无分辨率）
                var trailerInfo = _scope.DB.Get('trailerInfo') || {};
                if (this.param.video_id === trailerInfo.video_id) {
                    resolution = trailerInfo.resolution;
                }
                this._getVideoInfo(this.param.video_id, resolution).then(function (res) {
                    playerConfig.playlist = _this2._getPlayOrigin((0, _extends3["default"])({}, _this2.param, {
                        image: playerConfig.image || '',
                        file: res.url,
                        bookmarks: res.bookmarks || []
                    }));
                    _this2._setupPlayer(playerConfig);
                });
            } else {
                playerConfig.playlist = this._getPlayOrigin(this.param);
                if (playerConfig.isLive) {
                    delete playerConfig.src;
                    delete playerConfig.file;
                }
                this._setupPlayer(playerConfig);
            }

            this.delegatesMethod();

            this._subPlayerEvents();
        }
    }, {
        key: '_setupPlayer',
        value: function _setupPlayer(playerConfig) {
            var _this3 = this;

            try {
                this.player.setup(playerConfig).then(function () {

                    // 加载频道错误提示cover
                    _this3._appendErrorCover();

                    _scope.MsgBus.Pub('Player.Ready', _this3);
                    if (_this3.useFakeUrl) {
                        _this3.player.stop();
                        _this3.player.setControls(false);
                    }
                    _this3.pptTimer = new _scope.Timer('Player.pptTimer', {
                        player: _this3.player,
                        timegap: 1000,
                        getPosition: function getPosition() {
                            return _this3.player.getPosition();
                        },
                        getPlayFile: function getPlayFile() {
                            var item = _this3.player.getPlaylistItem(0);
                            return item && item.sources;
                        }
                    });
                    _this3.pptTimer.start();
                }, function (error) {
                    _scope.MsgBus.Pub('Player.SetupError', error);
                    if (_this3._getUserInArrearsCode().code) {
                        _this3._appendErrorCover();
                        _this3._displayErrorCover();
                    }
                });
            } catch (e) {
                console.warn(e); // eslint-disable-line
                _scope.MsgBus.Pub('Player.SetupError', e);
                return;
            }
        }
    }, {
        key: '_appendErrorCover',
        value: function _appendErrorCover() {
            var container = document.getElementById(this.id);
            if (!container) {
                return;
            }

            this.playerErrorCoverDom = document.createElement('div');
            this.playerErrorCoverDom.className = 'mudu-reset extra-error-cover';
            this.playerErrorCoverDom.style = 'display: none; position: absolute; inset: 0px; background: #000; opacity: 0.8; font-size: 18px; color: #fff;  text-align: center; white-space: break-spaces; padding-top: 20%; line-height: 1.3';
            container.appendChild(this.playerErrorCoverDom);
        }
    }, {
        key: '_displayErrorCover',
        value: function _displayErrorCover() {
            var errCode = this._getUserInArrearsCode();
            this.playerErrorCoverDom.innerText = '\u56E0\u7BA1\u7406\u5458\u8C03\u8BD5(\u4EE3\u7801' + errCode.code + ')\r\n\u8282\u76EE\u6682\u65F6\u65E0\u6CD5\u89C2\u770B\uFF0C\u8BF7\u7A0D\u5019';
            this.playerErrorCoverDom.style.display = 'block';
            if (this.player) {
                this.player.stop();
            }
        }
    }, {
        key: '_hideErrorCover',
        value: function _hideErrorCover() {
            this.playerErrorCoverDom.style.display = 'none';
        }
    }, {
        key: '_subPlayerEvents',
        value: function _subPlayerEvents() {
            var _this4 = this;

            try {
                this.player.on('play', function () {
                    _this4.timer.start();
                    _scope.MsgBus.Pub('Player.Play', _this4);
                });
            } catch (e) {
                console.warn(e); // eslint-disable-line
                this.player.stop();
                _scope.MsgBus.Pub('Player.PlayError', e);
            }
            this.player.on('buffer', function () {
                _scope.MsgBus.Pub('Player.Waiting', _this4);
            });
            this.player.on('pause', function () {
                _this4.timer.stop();
                _scope.MsgBus.Pub('Player.Stoped', _this4);
            });
            this.player.on('complete', function () {
                _this4.timer.stop();
                _scope.MsgBus.Pub('Player.Ended', _this4);
            });
            this.player.on('switchQuality', function () {
                _scope.MsgBus.Pub('Player.SwitchQuality', _this4);
            });
            this.player.on('error', function () {
                _scope.MsgBus.Pub('Player.Error', _this4);
                // error后stop播放器
                _this4.stop();
            });
        }
    }, {
        key: '_getUserInArrearsCode',
        value: function _getUserInArrearsCode() {
            return _scope.DB.Get('User.Arrears.Status') || {}; // 获取用户欠费状态的errCode
        }
    }, {
        key: '_listenBrowserEvent',
        value: function _listenBrowserEvent() {
            var _this5 = this;

            var feecb = function feecb() {
                _this5.timer.task && _this5.timer.start();
            };
            _scope.Utils.addEventListener(window, 'beforeunload', feecb);
            _scope.Utils.addEventListener(window, 'pagehide', feecb);
            _scope.Utils.addEventListener(window, 'pageshow', feecb);
            _scope.Utils.addEventListener(document, 'visibilitychange', feecb);
            _scope.Utils.addEventListener(window, 'unload', feecb);
        }
    }, {
        key: '_getVideoInfo',
        value: function _getVideoInfo(video_id, resolution) {
            var _this6 = this;

            return new _promise2["default"](function (resolve, reject) {
                if (!video_id) {
                    return;
                }
                var nowTimeStamp = Date.parse(new Date().toString()) / 1000;
                return Fetcher.Get(config.API_DOMAIN + '/videos/view/act/' + _this6.actHashId + '/video?video_id=' + video_id + '&timestamp=' + nowTimeStamp + '&resolution=' + (resolution || ''), function (data) {
                    var res = JSON.parse(data);
                    if (res.errcode === 1000) {
                        resolve(res.data);
                    } else {
                        reject('error');
                    }
                }, {
                    sign: md5(_scope.Utils.GetCookie('Token') + nowTimeStamp)
                });
            });
        }
    }, {
        key: 'load',
        value: function load(_ref, autoPlay) {
            var _this7 = this;

            var _ref2 = (0, _slicedToArray3["default"])(_ref, 1),
                param = _ref2[0];

            if (param.video_id) {
                var resolution = ''; // 如果能匹配到回放视频，就用回放视频的分辨率（其他视频暂无分辨率）
                var trailerInfo = _scope.DB.Get('trailerInfo') || {};
                if (param.video_id === trailerInfo.video_id) {
                    resolution = trailerInfo.resolution;
                }
                return this._getVideoInfo(param.video_id, resolution).then(function (res) {
                    return _this7.player.load(_this7._getPlayOrigin((0, _extends3["default"])({}, param, { file: res.url, bookmarks: res.bookmarks }))).then(function () {
                        if (_this7.useFakeUrl) {
                            _this7.player.stop();
                            _this7.player.setControls(false);
                        } else {
                            _this7.player.setControls(typeof param.controls !== 'undefined' ? param.controls : true);
                        }
                    });
                });
            }
            var playerAutoPlay = autoPlay || param.autoPlay;
            return this.player.load(this._getPlayOrigin(param), playerAutoPlay).then(function () {
                if (_this7.useFakeUrl) {
                    _this7.player.stop();
                    _this7.player.setControls(false);
                } else {
                    _this7.player.setControls(typeof param.controls !== 'undefined' ? param.controls : true);
                }
            });
        }
    }, {
        key: 'play',
        value: function play() {
            var playerConfigIsLive = false;
            try {
                var activeConfig = this.player._config && this.player._config.playlist.filter(function (item) {
                    return !!item.active;
                })[0];
                playerConfigIsLive = activeConfig && activeConfig.isLive;
            } catch (error) {
                // 没拿到值就认为不是播直播
            }
            var listLiveConfig = _scope.DB.Get('listLiveConfig');
            // 列表直播中调用play，或者之前用过列表直播，重新load player
            if (playerConfigIsLive && listLiveConfig && (listLiveConfig.isLiving || listLiveConfig.address)) {
                this.load([{
                    isLive: true
                }], true);
            } else {
                this.timer.start();
                this.player.play();
                _scope.MsgBus.Pub('Player.Play', this);
            }
        }
    }, {
        key: 'stop',
        value: function stop() {
            var state = this.player.getState();
            var isPlaying = state === 'playing' || state === 'buffering';
            this.timer.stop();
            isPlaying && this.player.stop();
            _scope.MsgBus.Pub('Player.Stoped', this);
        }
    }, {
        key: 'pause',
        value: function pause() {
            this.timer.stop();
            this.player.pause();
            _scope.MsgBus.Pub('Player.Paused', this);
        }
    }, {
        key: 'setPlayerSize',
        value: function setPlayerSize(w, h) {
            return this.player.resize(w, h);
        }
    }, {
        key: 'remove',
        value: function remove() {

            if (this.timer) {
                this.timer.stop();
            }
            if (this.pptTimer) {
                this.pptTimer.stop();
            }
            this.player.remove();
        }

        // 将video info转换成player的参数格式

    }, {
        key: '_transformVideoInfoToPlay',
        value: function _transformVideoInfoToPlay(videoInfo) {
            var highlights = videoInfo.highlights || [];
            if (!highlights.length && videoInfo.bookmarks) {
                highlights = videoInfo.bookmarks.map(function (v) {
                    return {
                        time: utils.transformTimeStrToNumber(v.time),
                        text: v.desc || ''
                    };
                });
            }
            return [{
                file: videoInfo.m3u8 || videoInfo.file,
                image: videoInfo.trailer_img || videoInfo.image || '',
                isLive: false,
                highlights: highlights,
                controls: typeof videoInfo.draggable !== 'undefined' ? videoInfo.draggable : true,
                isHideProgress: typeof videoInfo.isHideProgress !== 'undefined' ? !videoInfo.triple_speed : false
            }];
        }
    }, {
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this8 = this;

            this.destroyKey = _scope.MsgBus.Sub('Destroy', function () {
                _this8.remove();
                _scope.MsgBus.UnSub(_this8.destroyKey);
            });
        }
    }, {
        key: '_getFakePlayParam',
        value: function _getFakePlayParam(param) {
            this.useFakeUrl = true;
            delete param.file;
            delete param.src;
            delete param.playlist;
            return [(0, _extends3["default"])({
                file: 'https://fake.xxx/xxx.m3u8',
                autoplay: false,
                image: _scope.DB.Get('liveAddrList')[0].image || ''
            }, param)];
        }
    }, {
        key: '_getLiveParam',
        value: function _getLiveParam(param) {
            delete param.file;
            delete param.src;
            delete param.playlist;

            // 先检查是否是列表直播，列表直播则返回列表直播地址
            var listLiveConfig = _scope.DB.Get('listLiveConfig');
            console.log(listLiveConfig.isLiving);
            if (listLiveConfig && listLiveConfig.isLiving) {
                return [(0, _extends3["default"])({}, param, {
                    file: listLiveConfig.address
                })];
            } else {
                // 只取第一路流
                var liveItem = _scope.DB.Get('liveAddrList')[0];

                return [(0, _extends3["default"])({}, liveItem, param)];
            }
        }

        // 获取播放视频源

    }, {
        key: '_getPlayOrigin',
        value: function _getPlayOrigin(param) {
            this.useFakeUrl = false;
            var errCode = this._getUserInArrearsCode() || {};
            // 播放直播
            if (param.isLive) {
                // 有直播错误码
                if (errCode.hasLiveErrcode) {
                    this._displayErrorCover();
                    return this._getFakePlayParam(param);
                }
                this._hideErrorCover();
                return this._getLiveParam(param);
            }

            // 有点播错误码
            if (errCode.hasTrailerErrcode) {
                this._displayErrorCover();
                return this._getFakePlayParam(param);
            }

            this._hideErrorCover();

            // 播放回看
            if (!param.isLive && !param.file) {
                var trailerInfo = _scope.DB.Get('trailerInfo') || {};
                if (trailerInfo.open) {
                    return this._transformVideoInfoToPlay(trailerInfo);
                }
            }

            // 播放其他视频
            var file = param.file || param.src;
            if (file) {
                var forceCutomHighlight = _scope.DB.Get('CUSTOM_FORCE_HIGHLIGHT') || [];
                return this._transformVideoInfoToPlay((0, _extends3["default"])({ bookmarks: forceCutomHighlight }, param, { file: file }));
            }

            // 都播不了，用假地址，避免player load报错
            return this._getFakePlayParam(param);
        }
    }, {
        key: 'delegatesMethod',
        value: function delegatesMethod() {
            delegates(this, 'player').method('seek').method('on').method('getPlaylist').method('getPlaylistItem').method('getState').method('getPosition').method('getMute').method('setMute').method('setVolume').method('getFullscreen').method('getHeight').method('getWidth').method('resize')
            // .method('getQualityLevels')
            // .method('getCurrentQuality')
            .method('switchQuality')
            // .method('getVisualQuality')
            // .method('setCurrentQuality')
            // .method('getAudioTracks')
            // .method('getCurrentAudioTrack')
            // .method('setCurrentAudioTrack')
            // .method('setCaptions')
            // .method('getCaptionsList')
            // .method('getCurrentCaptions')
            // .method('setCurrentCaptions')
            .method('getControls')
            // .method('getSafeRegion')
            // .method('addButton')
            // .method('removeButton')
            .method('setControls').method('playAd');
            // .method('setFlashTip')
            // .method('getJWVersion');
        }
    }]);
    return Player;
}();



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/modules/Player.js
 ** module id = 25
 ** module chunks = 1
 **/